// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.marquee-list[data-v-7becc1cd] {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n}\nul.marquee-list li[data-v-7becc1cd] {\n  width: auto;\n  cursor: pointer;\n  display: inline-block;\n  margin: 0px 5px;\n  box-sizing: border-box;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
